import React from 'react';
import PropTypes from 'prop-types';
import LoadingComponent from './../LoadingComponent';

function PickupCount({ countText, count, total, loading }) {
    const loader = (
        <div className="buttonLoader">
            <LoadingComponent isLoading={true} />
        </div>
    );
    return (
        <div className="pickup">
            {loading ? (
                loader
            ) : (
                <p>
                    <span>{`${countText} ${count}`}</span>
                    {`/${total}`}
                </p>
            )}
        </div>
    );
}

PickupCount.propTypes = {
    // To display the heading in the card
    countText: PropTypes.string,
    count: PropTypes.number,
    total: PropTypes.number,
    loading: PropTypes.bool,
};

PickupCount.defaultProps = {
    text: '',
    count: null,
    total: null,
    loading: false,
};

export default PickupCount;
